module.exports = __webpack_public_path__ + "static/media/top_banner_1.f64d2f63.png";